<div class="container-fluid" style="padding:0">
    <div class="row">
        <div class="col-lg-2">
            <app-navbar></app-navbar>
        </div>
        <div class="col-lg-10">
            <div class="row">
                <div class="col-lg-9">
                    <br>
                    <h2>Precio Anillos</h2>
                </div>

                <table class="table table-striped row-border hover">
                    <thead class="thead-dark">
                        <tr>
                            <td>Metal</td>
                            <td>Peso</td>
                            <td>Precio</td>
                            <td>Editar</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let anillo of anillos">
                            <td>{{anillo.metal}}</td>
                            <td>{{anillo.gramaje}}</td>
                            <td>{{anillo.precio | currency}}</td>
                            <td>
                                <a (click)="getDetallePrecioAnillo(anillo.id)">
                                <svg  style="color:gray" width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-pencil-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z"/>
                                </svg></a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>



<div id="clickEditar" (click)="openModal(myModalEditar)"></div>

<ng-template #myModalEditar let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h2>Editar Anillo</h2>
      <button type="button" class="close" (click)="dismissAll()" data-dismiss="modal">&times;</button>
    </div>

    <div class="modal-body">
        <span>Metal:</span><br>
        <select #metalEdit [(ngModel)]="formularioEdit.metal">
            <option value="Oro 10 Kilates" [attr.selected]="formularioEdit.gramaje=='oro' ? true : null">Oro 10 Kilates</option>
            <option value="Oro 14 Kilates" [attr.selected]="formularioEdit.gramaje=='oro' ? true : null">Oro 14 Kilates</option>
            <option value="Plata" [attr.selected]="formularioEdit.gramaje=='plata' ? true : null">Plata</option>
        </select><br><br>
        <span>Peso:</span><br>
        <select #pesoEdit [(ngModel)]="formularioEdit.gramaje" class="negro">
            <option value="3-4" class="negro" [attr.selected]="formularioEdit.gramaje=='3-4' ? true : null">3-4 gramos</option>
            <option value="5-6" class="negro" [attr.selected]="formularioEdit.gramaje=='5-6' ? true : null">5-6 gramos</option>
        </select><br><br>
        <input type="text" class="form-control" placeholder="Precio" [(ngModel)]="formularioEdit.precio"><br>
    </div>

    <div class="modal-footer">
        <button class="btn btn-primary" (click)="updateAnilloPrecio(anilloId, metalEdit.value, pesoEdit.value)">Actualizar</button>
    </div>
</ng-template>